import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appKeyFormat]'
})
export class KeyFormatDirective {

  constructor(private readonly el: ElementRef) {
  }

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Boşlukları ve nokta işaretini kaldırarak büyük harfe çevirme
    // value = value.toUpperCase().replace(/[\s.]/g, '');

    // Sadece harf, rakam ve tire kabul eden regex
    value = value.toUpperCase().replaceAll(/[^A-Z0-]/g, '');

    this.el.nativeElement.value = value;
    input.value = value;
  }
}
